import { AbstractControl } from '@angular/forms';
import { getActiveMarket, ibanProfileForCountry } from '../config/markets.config';

export function ibanValidatorForCountry(country: string) {
    const pattern = new RegExp(ibanProfileForCountry(country).pattern);

    return (control: AbstractControl): { [key: string]: any } | null => {
        let value = control.value;
        if (!value) {
            return null;
        }
        value = value.toUpperCase().replace(/\s/g, '');
        if (!pattern.test(value)) {
            return { iban: true };
        }

        return null;
    };
}

export const IbanValidator = function (control: AbstractControl): { [key: string]: any } | null {
    return ibanValidatorForCountry(getActiveMarket().country)(control);
};
